/**
 * Campaign Room — API
 *
 * Sprint 4 · Project Symphony · Read-only.
 */
import { http } from "@/shared/api/http";
import type { CampaignRoomPayload } from "./types";

export const getCampaignRoom = (
  blueprintId: string,
): Promise<CampaignRoomPayload> =>
  http<CampaignRoomPayload>(`/orchestration/blueprints/${blueprintId}/room`);
